/**
 * Created by Hp on 12/05/2017.
 */
(function () {

    'use strict';

    class InterventionPlanningDialogCtrl {
        constructor($mdDialog, $http) {
            this.http = $http;
            this.dialog = $mdDialog;
        }

        static get $inject() {
            return ["$mdDialog", "$http"];
        }

        cancel() {
            this.dialog.cancel();
        }

        submit() {
            this.http.post(`/api/intervention/${!_.isNil(this.model.id) ? this.model.id + "/" : ""}`, this.model)
                .then(response => this.dialog.hide(response.data));
        }
    }

    module.exports = {
        multiple: true,
        controllerAs: "vm",
        controller: InterventionPlanningDialogCtrl,
        bindToController: true,
        parent: $(document.body),
        clickOutsideToClose: false,
        focusOnOpen: false,
        template: require("../views/intervention-planning-dialog.html"),
    };
})();